var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-col',{attrs:{"align":"center"}},[_c('v-card',[_vm._v(" กรุณาแสกนคิวอาร์โค้ดเพื่อใช้งาน ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }